import { runAnalyticsTask } from "../../service/analytics-defer/analytics-defer";

/**
 * Sibling to `fireModifiedComponentTypePageLoadEvent` from
 * `@directv-digital/dds.services.analytics-service`. Fires the same
 * `dynamic_component` event but with `dim_name: 'not displayed'` so the
 * ineligible cohort on personalization slots (empty-default variants) is
 * tracked in GA alongside the displayed cohort.
 *
 * Mirrors the package's `fireDataLayerEvent` parent-window handling so it
 * works inside the Storyblok Visual Editor iframe.
 *
 * Will move into `@directv-digital/dds.services.analytics-service` later;
 * tracked under WAT-10440.
 */
export function fireDynamicComponentNotDisplayedEvent(dimValue: string): void {
  // WAT-12687: trim CMS-authored dim_value; anything not a non-empty string is skipped.
  const trimmed = typeof dimValue === "string" ? dimValue.trim() : "";
  if (typeof window === "undefined" || !trimmed) {
    return;
  }

  let targetWindow: Window = window;
  try {
    if (window.parent && window.parent !== window) {
      targetWindow = window.parent;
    }
  } catch {
    targetWindow = window;
  }

  try {
    const w = targetWindow as any;
    w.dataLayer = w.dataLayer || [];
    runAnalyticsTask(() => {
      w.dataLayer.push({
        event: "trackEvent",
        event_name: "dynamic_component",
        dim_name: "not displayed",
        dim_value: trimmed
      });
    });
  } catch (error) {
    console.error("Error firing dynamic_component not-displayed event", error);
  }
}
